import { CUSTOM_ELEMENTS_SCHEMA, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartComponent } from './start/start.component';
import { LoginFormComponent } from './start/login-form/login-form.component';
import { PwForgottenComponent } from './start/pw-forgotten/pw-forgotten.component';
import { PwSetnewComponent } from './start/pw-setnew/pw-setnew.component';
import { ConfirmEmailComponent } from './start/confirm-email/confirm-email.component';
import { RegisterComponent } from './start/register/register.component';
import { TwoFactorauthComponent } from './start/two-factorauth/two-factorauth.component';
import { PrivacyComponent } from './view/privacy/privacy.component';
import { ImprintComponent } from './view/imprint/imprint.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CookieService } from 'ngx-cookie-service';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { HttpConfigInterceptor } from './service/http.interceptor';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { BtnComponent } from './components/btn/btn.component';
import { AllcomponentsComponent } from './view/allcomponents/allcomponents.component';
import { IconModule } from './components/icon/icon.module';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { InputComponent } from './components/input/input.component';
import { SelectComponent } from './components/select/select.component';
import { BadgeComponent } from './components/badge/badge.component';
import { StartLogoComponent } from './components/start-logo/start-logo.component';
import { SegmentControlComponent } from './components/segment-control/segment-control.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DividerComponent } from './components/divider/divider.component';
import { TermsComponent } from './view/terms/terms.component';
import { CardComponent } from './components/card/card.component';
import { CardFooterComponent } from './components/card/card-footer/card-footer.component';
import { CardContentComponent } from './components/card/card-content/card-content.component';
import { NomobileuseComponent } from './view/nomobileuse/nomobileuse.component';
import { HomeComponent } from './home/home.component';
import { HomeHeaderComponent } from './home/home-header/home-header.component';
import { UseraccountComponent } from './home/user/useraccount/useraccount.component';
import { StreamDashboardComponent } from './home/user/stream-dashboard/stream-dashboard.component';
import { FaqComponent } from './view/faq/faq.component';
import { UserAvatarComponent } from './home/home-header/user-avatar/user-avatar.component';
import { SegmentControlItemComponent } from './components/segment-control/segment-control-item/segment-control-item.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { SettingsComponent } from './home/user/settings/settings.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { StepComponent } from './components/stepper/step/step.component';
import { BasicSettingsComponent } from './home/user/useraccount/basic-settings/basic-settings.component';
import { LicenseSettingsComponent } from './home/user/useraccount/license-settings/license-settings.component';
import { TabControlComponent } from './components/tab-control/tab-control.component';
import { TabComponent } from './components/tab-control/tab/tab.component';
import { RangeControlComponent } from './components/range-control/range-control.component';
import { SelectBtnComponent } from './components/select-btn/select-btn.component';
import { NewstreamComponent } from './home/user/newstream/newstream.component';
import { BasicinfosComponent } from './home/user/settings/basicinfos/basicinfos.component';
import { ProjectknowledgeComponent } from './home/user/settings/projectknowledge/projectknowledge.component';
import { TeammembersComponent } from './home/user/settings/teammembers/teammembers.component';
import { BtnModule } from './components/btn/btn.module';
import { InviteComponent } from './components/invite/invite.component';
import { ProgressComponent } from './components/progress/progress.component';
import { CalcFileSizeInKbPipe } from './pipes/calc-file-size-in-kb.pipe';
import { StreamoverviewComponent } from './home/user/newstream/streamoverview/streamoverview.component';
import { TrackHeaderComponent } from './home/user/track-header/track-header.component';
import { InitStreamViewComponent } from './components-track/init-stream-view/init-stream-view.component';
import { UsermenueComponent } from './home/home-header/usermenue/usermenue.component';
import { TeamheaderComponent } from './home/home-header/teamheader/teamheader.component';
import { AiChatComponent } from './home/user/ai-chat/ai-chat.component';
import { MessagesComponent } from './home/home-header/messages/messages.component';
import { BasicIdeaComponent } from './components-track/basic-idea/basic-idea.component';
import { InstructionsComponent } from './components-track/instructions/instructions.component';
import { AiControlComponent } from './components/ai-control/ai-control.component';
import { PromotionComponent } from './start/promotion/promotion.component';
import { AiControlResultComponent } from './components/ai-control-result/ai-control-result.component';
import { UserTinderComponent } from './components-track/user-tinder/user-tinder.component';
import { SkippedUserComponent } from './components-track/user-tinder/skipped-user/skipped-user.component';
import { PrioritizeUserComponent } from './components-track/user-tinder/prioritize-user/prioritize-user.component';
import { ShowResultsListComponent } from './components-track/show-results-list/show-results-list.component';
import { AiControlChatComponent } from './components/ai-control-chat/ai-control-chat.component';
import { AiControlSelectComponent } from './components/ai-control-select/ai-control-select.component';
import { ClosingStreamViewComponent } from './components-track/closing-stream-view/closing-stream-view.component';
import { MarkdownModule } from 'ngx-markdown';
import { CamelcasePipe } from './pipes/camelcase.pipe';
import { FullPersonaComponent } from './components-track/user-tinder/full-persona/full-persona.component';
import { LocalTimeDatePipe } from './pipes/local-time-date.pipe';
import { RenameStreamComponent } from './home/user/stream-dashboard/rename-stream/rename-stream.component';
import { FeedbackCardComponent } from './components-track/feedback-card/feedback-card.component';
import { MentorselectComponent } from './components-track/feedback-card/mentorselect/mentorselect.component';
import { EasyTwoPopupComponent } from './components-track/closing-stream-view/easy-two-popup/easy-two-popup.component';
import { InformationSharedPopupComponent } from './components-track/closing-stream-view/information-shared-popup/information-shared-popup.component';
import { UserInsightMappingComponent } from './components-track/user-insight-mapping/user-insight-mapping.component';
import { InsightControlComponent } from './components-track/user-insight-mapping/insight-control/insight-control.component';
import { AddPinComponent } from './components-track/feedback-card/add-pin/add-pin.component';
import { DetailTrackRowComponent } from './home/user/stream-dashboard/detail-track-row/detail-track-row.component';
import { DropDownComponent } from './home/user/stream-dashboard/detail-track-row/drop-down/drop-down.component';
import { FeedbackPinsDashboardComponent } from './home/user/stream-dashboard/detail-track-row/feedback-pins-dashboard/feedback-pins-dashboard.component';
import { KeyResultDashboardComponent } from './home/user/stream-dashboard/detail-track-row/key-result-dashboard/key-result-dashboard.component';
import { ResultPreviewComponent } from './home/user/stream-dashboard/result-preview/result-preview.component';
import { PinComponent } from './home/user/stream-dashboard/pin/pin.component';
import { InternLandingPageComponent } from './components-track/intern-landing-page/intern-landing-page.component';
import { UserRagComponent } from './home/user/generic-stream/user-rag/user-rag.component';
import { UploadRaggerComponent } from './components-track/basic-idea/upload-ragger/upload-ragger.component';
import { ProductIdeasComponent } from './home/user/generic-stream/user-rag/product-ideas/product-ideas.component';
import { NewTrackRunComponent } from './home/user/new-track-run/new-track-run.component';
import { KeyResultItemComponent } from './home/user/stream-dashboard/detail-track-row/key-result-dashboard/key-result-item/key-result-item.component';
import { SetNewPasswordComponent } from './components/set-new-password/set-new-password.component';
import { WebresearchComponent } from './home/user/generic-stream/webresearch/webresearch.component';
import { MarketanalyseComponent } from './components-track/marketanalyse/marketanalyse.component';
import { RestartChatComponent } from './home/user/ai-chat/restart-chat/restart-chat.component';
import { CloseStreamComponent } from './components-track/close-stream/close-stream.component';
import { GetIndustryNameByIdPipe } from './pipes/get-industry-name-by-id.pipe';
import { GetBusinessTypeNameByIdPipe } from './pipes/get-business-type-name-by-id.pipe';
import { GetIdeaTypeNameByIdPipe } from './pipes/get-idea-type-name-by-id.pipe';
import { ChangePasswordComponent } from './home/user/useraccount/basic-settings/change-password/change-password.component';
import { MentorComponent } from './home/mentor/mentor.component';
import { GreetingDialogComponent } from './components-track/closing-stream-view/greeting-dialog/greeting-dialog.component';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { StartupNavigatorComponent } from './home/mentor/startup-navigator/startup-navigator.component';
import { GenericStreamDashboardComponent } from './home/user/generic-stream-dashboard/generic-stream-dashboard.component';
import { TimeToLocaleDateStringPipe } from './pipes/time-to-locale-date-string.pipe';
import { StreamRowComponent } from './home/user/generic-stream-dashboard/stream-row/stream-row.component';
import { SelectStreamComponent } from './home/user/generic-stream-dashboard/select-stream/select-stream.component';
import { NameStreamComponent } from './home/user/generic-stream-dashboard/name-stream/name-stream.component';
import { GenericStreamComponent } from './home/user/generic-stream/generic-stream.component';
import { GenHeaderComponent } from './home/user/generic-stream/gen-header/gen-header.component';
import { GetCategoryNameByIdPipe } from './pipes/get-category-name-by-id.pipe';
import { SearchResultComponent } from './home/user/generic-stream/webresearch/search-result/search-result.component';
import { InviteeComponent } from './components/mentor/invitee/invitee.component';
import { ActiveFounderComponent } from './components/mentor/active-founder/active-founder.component';
import { ActiveFounderDetailsComponent } from './components/mentor/dialogs/active-founder-details/active-founder-details.component';
import { ConfirmComponent } from './components/dialogs/confirm/confirm.component';
import { StepPreviewComponent } from './home/user/generic-stream/step-preview/step-preview.component';
import { StreamResultListComponent } from './home/user/generic-stream/stream-result-list/stream-result-list.component';
import { StepNotCompletedComponent } from './home/user/generic-stream/step-not-completed/step-not-completed.component';
import { GenericResultViewComponent } from './home/user/generic-stream/generic-result-view/generic-result-view.component';
import { GenericResultScreenComponent } from './home/user/generic-stream/generic-result-screen/generic-result-screen.component';
import { GenHeaderResultComponent } from './home/user/generic-stream/gen-header-result/gen-header-result.component';
import { CongratsComponent } from './home/user/generic-stream/generic-result-screen/congrats/congrats.component';
import { CongratSignupComponent } from './start/congrat-signup/congrat-signup.component';
import { SafeHtmlPipe } from './shared/pipes/safe-html.pipe';
import { GenericHtmlViewStandaloneComponent } from './home/user/generic-stream/generic-html-view-standalone/generic-html-view-standalone.component';
import { HtmlTemplateViewComponent } from './home/user/generic-stream/generic-html-view-standalone/html-template-view/html-template-view.component';
import { EditHtmlImageComponent } from './home/user/generic-stream/generic-html-view-standalone/edit-html-image/edit-html-image.component';
import { GenericStreamResultComponent } from './components/generic-stream-result/generic-stream-result.component';
import { AppdataService } from './service/appdata.service';
import { CongratResetpwLinkSentComponent } from './start/congrat-resetpw-link-sent/congrat-resetpw-link-sent.component';
import { TemplateBmcComponentComponent } from './home/user/generic-stream/generic-result-view/template-bmc-component/template-bmc-component.component';
import { TemplateKeyquestionsComponent } from './home/user/generic-stream/generic-result-view/template-keyquestions/template-keyquestions.component';
import { CompanyLogoComponent } from './components/company-logo/company-logo.component';
import { RagFileUploadComponent } from './home/user/generic-stream/user-rag/rag-file-upload/rag-file-upload.component';
import { RagRawTextComponent } from './home/user/generic-stream/user-rag/rag-raw-text/rag-raw-text.component';
import { RagStreamReferenceComponent } from './home/user/generic-stream/user-rag/rag-stream-reference/rag-stream-reference.component';
import { ShareAssetComponent } from './home/user/generic-stream/generic-html-view-standalone/share-asset/share-asset.component';
import { HeaderComponent } from './home/user/generic-stream-dashboard/header/header.component';
import { StreamCardComponent } from './home/user/generic-stream-dashboard/stream-card/stream-card.component';
import { CopyTextToClipboardComponent } from './components/dialogs/copy-text-to-clipboard/copy-text-to-clipboard.component';
import { ConfirmDeletionComponent } from './start/confirm-deletion/confirm-deletion.component';
import { RejectDeletionComponent } from './start/reject-deletion/reject-deletion.component';
import { ShortRegistrationComponent } from './start/short-registration/short-registration.component';
import { StreamInfoCardComponent } from './home/user/generic-stream-dashboard/stream-info-card/stream-info-card.component';
import { DeleteCompanyComponent } from './home/user/useraccount/basic-settings/delete-company/delete-company.component';
import { AwaitingAccessFromCoachComponent } from './start/awaiting-access-from-coach/awaiting-access-from-coach.component';
import { PromotionVideoPopupComponent } from './components/promotion-video-popup/promotion-video-popup.component';

async function initApp(appDataService: AppdataService,): Promise<void> {
    await appDataService.loadAppData();
}

@NgModule({
    declarations: [
        AppComponent,
        StartComponent,
        LoginFormComponent,
        PwForgottenComponent,
        PwSetnewComponent,
        ConfirmEmailComponent,
        RegisterComponent,
        TwoFactorauthComponent,
        PrivacyComponent,
        ImprintComponent,
        SnackbarComponent,
        // BtnComponent,
        AllcomponentsComponent,
        // IconComponent,
        CheckboxComponent,
        InputComponent,
        SelectComponent,
        BadgeComponent,
        StartLogoComponent,
        DividerComponent,
        TermsComponent,
        CardComponent,
        CardFooterComponent,
        CardContentComponent,
        NomobileuseComponent,
        HomeComponent,
        HomeHeaderComponent,
        UseraccountComponent,
        StreamDashboardComponent,
        FaqComponent,
        UserAvatarComponent,
        SegmentControlComponent,
        SegmentControlItemComponent,
        SpinnerComponent,
        TextareaComponent,
        SettingsComponent,
        StepperComponent,
        StepComponent,
        BasicSettingsComponent,
        LicenseSettingsComponent,
        TabControlComponent,
        TabComponent,
        RangeControlComponent,
        SelectBtnComponent,
        NewstreamComponent,
        BasicinfosComponent,
        ProjectknowledgeComponent,
        TeammembersComponent,
        InviteComponent,
        ProgressComponent,
        CalcFileSizeInKbPipe,
        StreamoverviewComponent,
        TrackHeaderComponent,
        InitStreamViewComponent,
        UsermenueComponent,
        TeamheaderComponent,
        AiChatComponent,
        MessagesComponent,
        BasicIdeaComponent,
        InstructionsComponent,
        AiControlComponent,
        PromotionComponent,
        AiControlResultComponent,
        UserTinderComponent,
        SkippedUserComponent,
        PrioritizeUserComponent,
        ShowResultsListComponent,
        AiControlChatComponent,
        AiControlSelectComponent,
        ClosingStreamViewComponent,
        CamelcasePipe,
        FullPersonaComponent,
        LocalTimeDatePipe,
        RenameStreamComponent,
        FeedbackCardComponent,
        MentorselectComponent,
        EasyTwoPopupComponent,
        InformationSharedPopupComponent,
        UserInsightMappingComponent,
        InsightControlComponent,
        AddPinComponent,
        DetailTrackRowComponent,
        DropDownComponent,
        FeedbackPinsDashboardComponent,
        KeyResultDashboardComponent,
        ResultPreviewComponent,
        PinComponent,
        InternLandingPageComponent,
        UserRagComponent,
        UploadRaggerComponent,
        ProductIdeasComponent,
        NewTrackRunComponent,
        KeyResultItemComponent,
        SetNewPasswordComponent,
        WebresearchComponent,
        MarketanalyseComponent,
        RestartChatComponent,
        CloseStreamComponent,
        GetIndustryNameByIdPipe,
        GetBusinessTypeNameByIdPipe,
        GetIdeaTypeNameByIdPipe,
        ChangePasswordComponent,
        MentorComponent,
        GreetingDialogComponent,
        DisclaimerComponent,
        StartupNavigatorComponent,
        GenericStreamDashboardComponent,
        TimeToLocaleDateStringPipe,
        StreamRowComponent,
        SelectStreamComponent,
        NameStreamComponent,
        GenericStreamComponent,
        GenHeaderComponent,
        GetCategoryNameByIdPipe,
        SearchResultComponent,
        InviteeComponent,
        ActiveFounderComponent,
        ActiveFounderDetailsComponent,
        ConfirmComponent,
        StepPreviewComponent,
        StreamResultListComponent,
        StepNotCompletedComponent,
        GenericResultScreenComponent,
        GenHeaderResultComponent,
        CongratsComponent,
        CongratSignupComponent,
        StreamInfoCardComponent,
        GenericHtmlViewStandaloneComponent,
        HtmlTemplateViewComponent,
        EditHtmlImageComponent,
        GenericStreamResultComponent,
        CongratResetpwLinkSentComponent,
        GenericResultViewComponent,
        TemplateBmcComponentComponent,
        TemplateKeyquestionsComponent,
        CompanyLogoComponent,
        RagFileUploadComponent,
        RagRawTextComponent,
        RagStreamReferenceComponent,
        ShareAssetComponent,
        HeaderComponent,
        StreamCardComponent,
        CopyTextToClipboardComponent,
        ConfirmDeletionComponent,
        RejectDeletionComponent,
        ShortRegistrationComponent,
        DeleteCompanyComponent,
        AwaitingAccessFromCoachComponent,
        PromotionVideoPopupComponent,
    ],
    imports: [
        SafeHtmlPipe,
        BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        IconModule,
        BtnModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        FormsModule,
        HttpClientModule,
        MarkdownModule.forRoot(),
        CommonModule
    ],
    providers: [
        CookieService,
        provideHttpClient(),
        provideAnimationsAsync(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true
        },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} },
        {
            provide: 'SANITIZER',
            useValue: {
                sanitize: (ctx: any, val: string) => val
            }
        },
        provideAppInitializer(() => initApp(inject(AppdataService))),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
